import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-none"
}
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = {
  key: 0,
  for: "opening-time",
  class: "mb-1"
}
const _hoisted_4 = { class: "p-field-radiobutton" }
const _hoisted_5 = { for: "opening-time-0.5" }
const _hoisted_6 = { class: "p-field-radiobutton" }
const _hoisted_7 = { for: "opening-time-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.deviceName)
      ? (_openBlock(), _createBlock("h3", _hoisted_1, _toDisplayString(_ctx.deviceName), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.OpeningTimeUpper")), 1),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settings.slots, (s, index) => {
      return (_openBlock(), _createBlock("div", {
        key: `slot-${index}`,
        class: "mb-4"
      }, [
        (s.hasMoreThanOneSlotSettings)
          ? (_openBlock(), _createBlock("h6", _hoisted_3, " Slot " + _toDisplayString(index), 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_RadioButton, {
            id: "opening-time-0.5",
            name: "opening-time",
            value: _ctx.CommandOpeningTime.HalfSecond,
            modelValue: s.commandOpeningTime,
            "onUpdate:modelValue": ($event: any) => (s.commandOpeningTime = $event),
            disabled: _ctx.readonly
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.HalfASecond")), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_RadioButton, {
            id: "opening-time-2",
            name: "opening-time",
            value: _ctx.CommandOpeningTime.TwoSecond,
            modelValue: s.commandOpeningTime,
            "onUpdate:modelValue": ($event: any) => (s.commandOpeningTime = $event),
            disabled: _ctx.readonly
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.TwoSecond")), 1)
        ])
      ]))
    }), 128))
  ]))
}